import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { MessageBar, MessageBarType } from '@fluentui/react';
import { TranslatableString } from '@rjsf/utils';
export default function ErrorList({ errors, registry, }) {
    const { translateString } = registry;
    return (_jsx(_Fragment, { children: errors.map((error, i) => {
            return (_jsx(MessageBar, { messageBarType: MessageBarType.error, isMultiline: false, dismissButtonAriaLabel: translateString(TranslatableString.CloseLabel), children: error.stack }, i));
        }) }));
}
//# sourceMappingURL=ErrorList.js.map